import pathfinder from '@fiverr-private/pathfinder';
import { localStorage, MONTH_IN_MS } from '@fiverr-private/futile';
import { ModalType, openFipMigrationModal } from '@fiverr-private/pro_migration';
import { getContext } from '@fiverr-private/fiverr_context';
import { AUCTION_SOURCE, MGMT_PAGE_TABS } from '../../constants';
import { BriefsMobileBridge } from '../../events/BriefsMobileBridge';
import { SHOW_PRO_MIGRATION_LS_KEY } from './constants';

export type MigrationType = 'rewards_program' | 'hourly' | 'high_budget';

export const migrateUserToPro = (briefId: any, type: MigrationType, isAllocatedAuctionInviteFlow: boolean) => {
    const { userId } = getContext();

    openFipMigrationModal({
        variant: ModalType.HeadlessSeamlessMigration,
        payload: {
            onSuccess: () => {
                window.location.href = pathfinder(
                    'dynamic_matching_management_page',
                    {
                        briefId,
                        tab: isAllocatedAuctionInviteFlow ? MGMT_PAGE_TABS.INVITE : MGMT_PAGE_TABS.OFFERS,
                    },
                    {
                        query: {
                            welcome_modal: 'migrated_from_job_post',
                            ...(isAllocatedAuctionInviteFlow && { source: AUCTION_SOURCE }),
                        },
                    }
                );
            },
            source: 'job_post_migration',
            biEnrichment: {
                pageElementName: 'job_post_migration',
                component: {
                    name: type,
                },
            },
        },
    });

    if (userId) {
        BriefsMobileBridge.onUpgradeToPro({
            buyerId: String(userId),
        });
    }
};

export const hasAttemptedMigrationRecently = () => {
    const attemptDateFromLS = localStorage.get(SHOW_PRO_MIGRATION_LS_KEY);

    if (!attemptDateFromLS) {
        return false;
    }

    const attemptDateMS = new Date(Number(attemptDateFromLS)).getTime();

    if (Date.now() - attemptDateMS >= MONTH_IN_MS) {
        return false;
    }

    return true;
};

export const setMigrationAttemptDateToLocalStorage = () => {
    localStorage.set(SHOW_PRO_MIGRATION_LS_KEY, Date.now());
};
